import { render, staticRenderFns } from "./PageText.vue?vue&type=template&id=89d0da88&"
import script from "./PageText.vue?vue&type=script&lang=js&"
export * from "./PageText.vue?vue&type=script&lang=js&"
import style0 from "./PageText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports